// The app store listings — same URL in every environment (unlike
// API_BASE_URL/DASH_LOGIN_URL, there's no local/dev/prod variant of the
// App Store or Play Store), so these are just plain constants rather
// than env vars threaded through Docker/Kustomize. Matches wrench-www's
// own lib/app-links.ts.
export const APPLE_APP_URL = 'https://apps.apple.com/us/app/wrenchboard/id1435718367';
export const ANDROID_APP_URL = 'https://play.google.com/store/apps/details?id=com.wrenchboard.users';
